"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validateCommands;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function validateCommands(commands, helpFn, clearFn, noDefaults) {
  var defaultCommands = {
    help: {
      description: 'Show a list of available commands.',
      fn: helpFn
    },
    clear: {
      description: 'Empty the terminal window.',
      explicitExec: true,
      fn: clearFn
    }
  };
  var immutables = Object.keys(defaultCommands);
  var validCommands; // Pre-register defaults

  if (!noDefaults) validCommands = _objectSpread({}, defaultCommands);else validCommands = {};

  for (var c in commands) {
    // Check that command contains a function
    if (typeof commands[c].fn !== 'function') {
      throw new Error("'fn' property of command '".concat(c, "' is invalid; expected 'function', got '").concat((0, _typeof2["default"])(commands[c].fn), "'"));
    } // Check that the command does not attempt to override immutables


    if (!noDefaults && immutables.includes(c)) {
      throw new Error("Attempting to overwrite default command '".concat(immutables[immutables.indexOf(c)], "'; cannot override default commands when noDefaults isn't set"));
    } // Add description if missing


    if (!commands[c].description) commands[c].description = 'None'; // Pass validation

    validCommands[c] = commands[c];
  }

  return validCommands;
}